import { Component, EventEmitter, inject, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectService } from "@domain/project/project.service";
import { filter, Observable } from "rxjs";

@Component({
  selector: "app-duplicate-button",
  templateUrl: "./duplicate-button.component.html",
  styleUrl: "./duplicate-button.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class DuplicateButtonComponent {
  private projectService = inject(ProjectService);

  @Output() duplicate = new EventEmitter();
  protected hasWritePermission$: Observable<boolean | undefined>;
  protected readonly tooltipTextDuplicateItem: string = $localize`:@@floorplan.button.duplicateItem:Element duplizieren`;

  constructor() {
    this.hasWritePermission$ = this.projectService.hasUserWritePermission$.pipe(
      filter((val): val is boolean => val !== undefined),
    );
  }
  protected onClickDuplicate() {
    this.duplicate.emit();
  }
}
